function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.3512 12.2908L19.3622 6.28075C19.6542 5.98775 19.6542 5.51275 19.3622 5.21975C19.0692 4.92675 18.5942 4.92675 18.3012 5.21975L12.2902 11.2298L6.28024 5.21975C5.98724 4.92675 5.51224 4.92675 5.21924 5.21975C4.92724 5.51275 4.92724 5.98775 5.21924 6.28075L11.2302 12.2908L5.21924 18.3007C4.92724 18.5938 4.92724 19.0687 5.21924 19.3617C5.51224 19.6547 5.98724 19.6547 6.28024 19.3617L12.2902 13.3518L18.3012 19.3617C18.5942 19.6547 19.0692 19.6547 19.3622 19.3617C19.6542 19.0687 19.6542 18.5938 19.3622 18.3007L13.3512 12.2908Z",
  fill: "currentColor"
});

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/iconClose.57dd7729.svg";
export { ForwardRef as ReactComponent };